import React from 'react';

/* Componet */
import About from './About';
import Project from './Project';
import Contact from './Contact';

const Main = () => (
    <main>
        <About />        

        <Project />

        <Contact />
    </main>
);

export default Main;